import { useEffect, useState } from "react";
import "./MindMappingReportAFourthSection.css";

const MindMappingReportAFourthSection = ({ res,toggle }) => {
  const [fundData, setFundData] = useState({
    level: "",
    accessibility: ""
  });

 useEffect(() => {
    if (!res?.affordability) return;

    // Normalize both strings: remove spaces and convert all dashes to a standard hyphen
    const normalize = (str) => str.replace(/\s/g, "").replace(/[–—]/g, "-");
    const userFundNormalized = normalize(res.affordability);

    const fundMapping = [
      { level: "< 0.5 M", access: "Medium" },
      { level: "1-2 M", access: "High" },
      { level: "5-7 M", access: "High" },
      { level: "10-20 M", access: "Very High" },
      { level: "> 100 M", access: "Very High (but complex)" }
    ];

    const match = fundMapping.find(f => normalize(f.level) === userFundNormalized);

    if (match) {
      setFundData({
        level: match.level, // Display the pretty version from mapping
        accessibility: match.access
      });
    } else {
      setFundData({
        level: res.affordability,
        accessibility: "N/A"
      });
    }
  }, [res]);

  return (
    <div className="mind-mapping-report-a-fourth-container">
      <div className={toggle?"table-adjust":"mind-mapping-report-a-fourth-final-table"}> 
        {/* Decorative Corners */}
        <span className="mind-mapping-report-a-fourth-corner mind-mapping-report-a-fourth-corner-top-left"></span>
        <span className="mind-mapping-report-a-fourth-corner mind-mapping-report-a-fourth-corner-top-right"></span>
        <span className="mind-mapping-report-a-fourth-corner mind-mapping-report-a-fourth-corner-bottom-left"></span>
        <span className="mind-mapping-report-a-fourth-corner mind-mapping-report-a-fourth-corner-bottom-right"></span>

        <div className="mind-mapping-report-a-fourth-module-title">
           <span className="module-prefix">Module 4:</span>  Fund Level Accessibility
        </div>

        {/* 4A: Simplified Fund Accessibility Table */}
        <div className="mind-mapping-report-a-fourth-table-scroll-wrapper">
          <table className="mind-mapping-report-a-fourth-inner-table">
            <thead>
              <tr>
                <th className="mind-mapping-report-a-fourth-col-sno">S.NO</th>
                <th>Fund Level</th>
                <th>Accessibility</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="mind-mapping-report-a-fourth-col-sno">4 A</td>
                <td className="mind-mapping-report-a-fourth-user-val">
                  {fundData.level}
                </td>
                <td className="mind-mapping-report-a-fourth-highlight">
                  {fundData.accessibility}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MindMappingReportAFourthSection;